var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericWrapperChart',{attrs:{"config":_vm.config},scopedSlots:_vm._u([(_vm.showFeedbackCard)?{key:"afterChart",fn:function(){return [_c('FeedbackCard',{attrs:{"message":_vm.messageFeedbackCard}})]},proxy:true}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }